
import { useI18n } from "vue-i18n"

export default {
  props: ["active", "equipmentId"],
  setup() {
    const { t } = useI18n()
  }
}
